import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "envelope",
  "use": "envelope-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"envelope\">\n   <g transform=\"translate(0,33.525424)\">\n     <path d=\"m 0,64 0,384 512,0 0,-384 -512,0 z m 480,352 -448,0 0,-320 448,0 0,320 z\" />\n     <rect x=\"352\" y=\"128\" width=\"96\" height=\"96\" />\n     <rect x=\"64\" y=\"256\" width=\"224\" height=\"32\" />\n     <rect x=\"64\" y=\"320\" width=\"224\" height=\"32\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol